import { useTranslation } from 'react-i18next';
import {
  getLandingScreen,
  type LandingLocale,
  type LandingScreenKey,
} from '../screenAssets';

export function useLandingScreens() {
  const { i18n, t } = useTranslation();
  const locale: LandingLocale = i18n.language?.startsWith('en') ? 'en' : 'el';

  const screen = (key: LandingScreenKey) => ({
    src: getLandingScreen(key, locale),
    alt: t(`phoneMockup.screens.${key}`),
  });

  return { locale, screen };
}
